import React, { useState } from "react";
import { Container, Typography, Grid, Box, Button, useTheme, alpha, Stack } from "@mui/material";
import CoinCard from "./CoinCard";
import ApplicationForm from "./ApplicationForm";
import { motion } from "framer-motion";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from "react-router-dom";

// Australian/New Zealand coins only
const australianCoins = [
  // ========== AUSTRALIAN COINS ==========
  {
    id: 101,
    name: "Kimberley Sunset - Argyle Pink Diamond Gold Coin",
    year: "2023",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$7,000 – $30,000",
    priceNum: 18500,
    image: "/assets/images/jp/0-KimberleySunset-ArgylePinkDiamond-Gold-2oz-HighRelief-Reverse.jpg",
    description: "2oz High Relief Gold Coin featuring rare Argyle Pink Diamond. A masterpiece of Australian minting.",
    metal: "Gold",
    category: "australia",
    hasDiamond: true,
    mint: "Perth Mint",
    country: "Australia"
  },
  {
    id: 102,
    name: "Australian Kangaroo 2oz Gold Proof with Pink Diamond",
    year: "2017",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$5,000 – $15,000",
    priceNum: 10000,
    image: "/assets/images/jp/4237-01-2017-australiankangaroo-2oz-gold-proof-pinkdiamond-onedge-highres.jpg",
    description: "Limited edition Kangaroo coin with genuine pink diamond. Only 100 minted worldwide.",
    metal: "Gold",
    category: "australia",
    hasDiamond: true,
    mint: "Perth Mint",
    country: "Australia"
  },
  {
    id: 103,
    name: "Queen Elizabeth II Diamond Jubilee Coin - 300 Dollars",
    year: "2012",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$3,000 – $7,000",
    priceNum: 5000,
    image: "/assets/images/jp/300 dollars 1952 2012 elizabeth commemorative coin.jpg",
    description: "Commemorating 60 years of reign. Features diamond accents and gold proof finish.",
    metal: "Gold",
    category: "australia",
    country: "Australia"
  },
  {
    id: 104,
    name: "Treasures of Australia Gold Locket Coin",
    year: "2014",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$120 – $650",
    priceNum: 385,
    image: "/assets/images/jp/treasures-of-the-world-australia-2014-1oz-gold-proof-locket-coin-with-gold-1.jpg",
    description: "1oz Gold Proof Locket Coin featuring Australian treasures. Unique hinged design.",
    metal: "Gold",
    category: "australia",
    country: "Australia"
  },
  {
    id: 105,
    name: "Australian Diamond Coin - Treasures of Australia",
    year: "2015",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$2,000 – $8,000",
    priceNum: 5000,
    image: "/assets/images/jp/Australian daimond coin treasure of australia.jpeg",
    description: "Features genuine diamonds celebrating Australia's natural treasures.",
    metal: "Gold/Silver",
    category: "australia",
    hasDiamond: true,
    country: "Australia"
  },
  {
    id: 106,
    name: "Elizabeth II 100 Dollars Gold Coin with Diamond",
    year: "2018",
    grade: "Proof 68",
    gradeNum: 68,
    price: "$2,500 – $6,000",
    priceNum: 4250,
    image: "/assets/images/jp/Australian Coin (Diamond) with elizabeth gold 100 dollars.jpeg",
    description: "Stunning gold coin featuring Queen Elizabeth II with diamond accent.",
    metal: "Gold",
    category: "australia",
    hasDiamond: true,
    country: "Australia"
  },
  {
    id: 107,
    name: "World's First Genuine Diamond Gold Coin",
    year: "2007",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$5,000 – $20,000",
    priceNum: 12500,
    image: "/assets/images/jp/world's-first-genuine-diamond-gold-coin-2-1.jpg",
    description: "The first-ever gold coin to feature a genuine diamond. Historic piece.",
    metal: "Gold",
    category: "australia",
    hasDiamond: true,
    country: "Australia"
  },
  {
    id: 108,
    name: "Elizabeth Regina Diamond Jubilee Silver Coin",
    year: "2012",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$120 – $400",
    priceNum: 260,
    image: "/assets/images/jp/elizabeth regina 1952 2012 daimond jubillee sivler.jpg",
    description: "Silver proof coin commemorating the Diamond Jubilee of Queen Elizabeth II.",
    metal: "Silver",
    category: "australia",
    country: "Australia"
  },
  {
    id: 109,
    name: "Elizabeth Regina Diamond Jubilee Gold Coin",
    year: "2012",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$2,500 – $6,000",
    priceNum: 4250,
    image: "/assets/images/jp/elizabeth regina 1952 2012 daimond jubillee gold.jpg",
    description: "Gold proof coin commemorating the Diamond Jubilee of Queen Elizabeth II.",
    metal: "Gold",
    category: "australia",
    country: "Australia"
  },
  {
    id: 110,
    name: "Elizabeth Regina Gratia Dei Coins",
    year: "1952-2012",
    grade: "Proof 68",
    gradeNum: 68,
    price: "$1,200 - $3,000",
    priceNum: 215,
    image: "/assets/images/jp/elizabeth regina gratia dei coins.jpg",
    description: "Historic coin featuring Elizabeth Regina Gratia Dei inscription.",
    metal: "Silver",
    category: "australia",
    country: "Australia"
  },
  {
    id: 111,
    name: "Queen Elizabeth II Commemoration Coin",
    year: "2012",
    grade: "Proof 68",
    gradeNum: 68,
    price: "$3,000–$6,000",
    priceNum: 425,
    image: "/assets/images/jp/queen elizabeth 2 commemeration coin.jpg",
    description: "Commemorative coin celebrating Queen Elizabeth II's reign.",
    metal: "Silver",
    category: "australia",
    country: "Australia"
  },

  // ========== NEW ZEALAND COINS ==========
  {
    id: 116,
    name: "New Zealand Kiwi 1oz Gold Proof",
    year: "2020",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$2,800 – $4,500",
    priceNum: 3650,
    image: "/assets/images/coins/New Zealand 1 oz Gold Kiwi.png",
    description: "Celebrating New Zealand's national bird. Stunning gold proof from NZ Mint featuring the iconic kiwi.",
    metal: "Gold",
    category: "newzealand",
    mint: "New Zealand Mint",
    country: "New Zealand"
  },
  {
    id: 117,
    name: "New Zealand Silver Fern 1oz Silver Proof",
    year: "2021",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$80 – $150",
    priceNum: 115,
    image: "/assets/images/coins/New Zealand Fern Silver Rounds.png",
    description: "Iconic silver fern design representing New Zealand. Perfect condition proof round.",
    metal: "Silver",
    category: "newzealand",
    mint: "New Zealand Mint",
    country: "New Zealand"
  },
  {
    id: 118,
    name: "New Zealand Lord of the Rings - The One Ring Silver Gold Proof Coin",
    year: "2023",
    grade: "Proof 70",
    gradeNum: 70,
    price: "$3,000 – $6,000",
    priceNum: 4500,
    image: "/assets/images/coins/New Zealand Lord of the Rings One Ring $1 Silver Gold Proof Coin.png",
    description: "Officially licensed Lord of the Rings coin featuring the One Ring inscription. Limited edition silver-gold proof.",
    metal: "Gold/Silver",
    category: "newzealand",
    mint: "New Zealand Mint",
    country: "New Zealand"
  },
  {
    id: 119,
    name: "New Zealand Maori Culture - Koru Silver Proof",
    year: "2022",
    grade: "Proof 69",
    gradeNum: 69,
    price: "$90 – $180",
    priceNum: 135,
    image: "/assets/images/coins/1 Dollar - Elizabeth II (4th Portrait; Maori Art - Koru; Silver Proof.png",
    description: "Celebrating Maori culture with traditional koru spiral design. Elegant silver proof featuring Queen Elizabeth II.",
    metal: "Silver",
    category: "newzealand",
    mint: "New Zealand Mint",
    country: "New Zealand"
  }
];

const FeaturedCoins = () => {
  const theme = useTheme();
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  const handlePriceInquiry = (coin) => {
    setSelectedCoin(coin);
    setFormOpen(true);
  };

  // Country data with flag images
  const countries = [
    {
      name: "Australia/NZ",
      path: "/",
      flagImage: "/assets/images/australia.jpg",
      flagAlt: "Australian Flag",
      variant: "contained"
    },
    {
      name: "Canada",
      path: "/canada",
      flagImage: "/assets/images/canada.jpg",
      flagAlt: "Canadian Flag",
      variant: "outlined"
    },
    {
      name: "USA",
      path: "/usa",
      flagImage: "/assets/images/usa.jpg",
      flagAlt: "USA Flag",
      variant: "outlined"
    },
    {
      name: "UK",
      path: "/uk",
      flagImage: "/assets/images/united kingdom.jpg",
      flagAlt: "UK Flag",
      variant: "outlined"
    }
  ];

  // Calculate stats
  const totalCoins = australianCoins.length;
  const goldCount = australianCoins.filter(c => c.metal === 'Gold' || c.metal === 'Gold/Silver').length;
  const diamondCount = australianCoins.filter(c => c.hasDiamond === true).length;
  const silverCount = australianCoins.filter(c => c.metal === 'Silver').length;

  return (
    <Box sx={{ 
      py: { xs: 8, md: 12 },
      backgroundColor: '#F5F5F5',
      position: 'relative',
    }}>
      {/* Decorative Lines */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
        }}
      />

      <Container maxWidth="xl">
        {/* Section Header */}
        <Box sx={{ mb: 8, textAlign: 'center' }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'primary.main',
                mb: 2,
                letterSpacing: '0.3em',
                textTransform: 'uppercase',
                fontWeight: 400,
              }}
            >
              Australia & New Zealand
            </Typography>
            
            <Typography variant="h2" sx={{ mb: 3, position: 'relative', color: '#2D2D2D' }}>
              Diamond, Gold & Silver
              <Box component="span" sx={{ color: 'primary.main', display: 'block' }}>
                Collector's Coins
              </Box>
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                maxWidth: '700px', 
                mx: 'auto',
                color: '#616161',
                fontSize: '1.2rem',
              }}
            >
              Featuring the world's finest diamond-inlaid, gold, and silver coins from the Perth Mint 
              and New Zealand Mint. Each piece is certified and authenticated.
            </Typography>
          </motion.div>
        </Box>

        {/* Region Navigation with Flag Images */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
          <Stack 
            direction="row" 
            spacing={3} 
            flexWrap="wrap" 
            justifyContent="center"
            alignItems="flex-start"
            sx={{
              '& .MuiButton-root': {
                minWidth: { xs: '100px', sm: '120px' },
              }
            }}
          >
            {countries.map((country, index) => (
              <Box key={index} sx={{ textAlign: 'center', width: '120px' }}>
                <Box
                  sx={{
                    width: '60px',
                    height: '40px',
                    mb: 1.5,
                    mx: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    backgroundColor: '#fff',
                    border: '1px solid rgba(0,0,0,0.1)',
                  }}
                >
                  <img 
                    src={country.flagImage} 
                    alt={country.flagAlt}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/60x40?text=Flag';
                    }}
                  />
                </Box>
                <Button
                  component={Link}
                  to={country.path}
                  variant={country.variant}
                  size="medium"
                  sx={{
                    px: 2,
                    py: 1.2,
                    width: '100%',
                    ...(country.variant === 'contained' && {
                      backgroundColor: 'primary.main',
                      color: '#000000',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                    }),
                    ...(country.variant === 'outlined' && {
                      borderColor: alpha('#9E9E9E', 0.3),
                      color: '#616161',
                      '&:hover': {
                        borderColor: 'primary.main',
                        color: 'primary.main',
                        backgroundColor: alpha('#C6A75E', 0.04),
                      },
                    }),
                    fontWeight: 600,
                    fontSize: '0.9rem',
                  }}
                >
                  {country.name}
                </Button>
              </Box>
            ))}
          </Stack>
        </Box>

        {/* Quick Stats */}
        <Box 
          sx={{ 
            mb: 6, 
            display: 'flex', 
            justifyContent: 'center',
            gap: { xs: 3, sm: 5, md: 8 },
            flexWrap: 'wrap',
          }}
        >
          {[
            { label: 'Australian/NZ Coins', value: `${totalCoins}+` },
            { label: 'Gold Coins', value: `${goldCount}+` },
            { label: 'Silver Coins', value: `${silverCount}+` },
            { label: 'Diamond-Inlaid', value: `${diamondCount}+` },
          ].map((stat, index) => (
            <Box 
              key={index} 
              sx={{ 
                textAlign: 'center',
                minWidth: { xs: '120px', sm: '140px' },
              }}
            >
              <Typography 
                variant="h4" 
                sx={{ 
                  color: 'primary.main', 
                  fontWeight: 600,
                  fontSize: { xs: '2rem', sm: '2.5rem' },
                }}
              >
                {stat.value}
              </Typography>
              <Typography 
                variant="body2" 
                color="#616161"
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                {stat.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Australian/NZ Coins Grid */}
        <Grid 
          container 
          spacing={4} 
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {australianCoins.map((coin, index) => (
            <Grid 
              item 
              xs={12} 
              sm={6} 
              md={4} 
              key={coin.id}
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.05 }}
                viewport={{ once: true }}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <CoinCard 
                  coin={coin} 
                  onPriceInquiry={() => handlePriceInquiry(coin)}
                />
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {/* Information Box about Price Ranges */}
        <Box 
          sx={{ 
            mt: 6, 
            p: 3, 
            backgroundColor: alpha('#C6A75E', 0.05),
            border: '1px solid',
            borderColor: alpha('#C6A75E', 0.2),
            borderRadius: 2,
            textAlign: 'center'
          }}
        >
         
        </Box>
      </Container>

      {/* Application Form */}
      <ApplicationForm 
        open={formOpen}
        onClose={() => setFormOpen(false)}
        coin={selectedCoin}
      />
    </Box>
  );
};
// At the very bottom of FeaturedCoins.jsx, add:
export { australianCoins };
export default FeaturedCoins;